import { api } from '../admin-api.js';

const NAV_ITEMS = [
    { label: 'Дашборд', path: '#/', type: 'nav' },
    { label: 'Аккаунты', path: '#/accounts', type: 'nav' },
    { label: 'Пользователи', path: '#/users', type: 'nav' },
    { label: 'Записи', path: '#/appointments', type: 'nav' },
    { label: 'Визиты', path: '#/visits', type: 'nav' },
    { label: 'Звонки', path: '#/calls', type: 'nav' },
    { label: 'Боты', path: '#/bots', type: 'nav' },
    { label: 'Единый бот', path: '#/unified-bot', type: 'nav' },
    { label: 'Отзывы', path: '#/reviews', type: 'nav' },
    { label: 'Биллинг', path: '#/billing', type: 'nav' },
    { label: 'Транзакции', path: '#/transactions', type: 'nav' },
    { label: 'Фичи тарифов', path: '#/feature-labels', type: 'nav' },
    { label: 'Статистика', path: '#/stats', type: 'nav' },
    { label: 'Трафик', path: '#/traffic', type: 'nav' },
    { label: 'SEO', path: '#/seo', type: 'nav' },
    { label: 'Партнёры', path: '#/partners', type: 'nav' },
    { label: 'Карта', path: '#/map', type: 'nav' },
    { label: 'Система', path: '#/system', type: 'nav' },
    { label: 'Почта', path: '#/mail', type: 'nav' },
    { label: 'Админы', path: '#/admins', type: 'nav' },
    { label: 'Роли и права', path: '#/roles', type: 'nav' },
    { label: 'Аудит', path: '#/audit', type: 'nav' },
    { label: 'Настройки', path: '#/settings', type: 'nav' },
];

let overlay = null;
let selectedIndex = 0;
let results = [];
let searchTimeout;

export function initCommandPalette() {
    document.addEventListener('keydown', (e) => {
        if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
            e.preventDefault();
            toggle();
        }
    });
}

function toggle() {
    if (overlay) { close(); return; }
    open();
}

function open() {
    selectedIndex = 0;
    results = [...NAV_ITEMS];

    overlay = document.createElement('div');
    overlay.className = 'cmd-palette-overlay';
    overlay.innerHTML = `
        <div class="cmd-palette">
            <input class="cmd-palette-input" placeholder="Поиск разделов и аккаунтов..." autofocus>
            <div class="cmd-palette-results" id="cmdResults"></div>
            <div class="cmd-palette-footer">
                <span><kbd>&uarr;&darr;</kbd> навигация</span>
                <span><kbd>Enter</kbd> перейти</span>
                <span><kbd>Esc</kbd> закрыть</span>
            </div>
        </div>`;

    document.body.appendChild(overlay);

    const input = overlay.querySelector('.cmd-palette-input');
    renderResults();

    input.addEventListener('input', (e) => {
        clearTimeout(searchTimeout);
        const q = e.target.value.trim();
        selectedIndex = 0;

        // Filter nav items immediately
        results = NAV_ITEMS.filter(item =>
            item.label.toLowerCase().includes(q.toLowerCase())
        );
        renderResults();

        // Search accounts with debounce
        if (q.length >= 2) {
            searchTimeout = setTimeout(() => searchAccounts(q), 300);
        }
    });

    input.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowDown') {
            e.preventDefault();
            selectedIndex = Math.min(selectedIndex + 1, results.length - 1);
            renderResults();
        } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            selectedIndex = Math.max(selectedIndex - 1, 0);
            renderResults();
        } else if (e.key === 'Enter') {
            e.preventDefault();
            if (results[selectedIndex]) navigate(results[selectedIndex]);
        } else if (e.key === 'Escape') {
            close();
        }
    });

    overlay.addEventListener('click', (e) => {
        if (e.target === overlay) close();
    });
}

async function searchAccounts(q) {
    try {
        const res = await api.get('/search', { q, limit: 5 });
        const { accounts = [], users = [] } = res || {};

        // Remove old search results, keep nav
        results = results.filter(r => r.type === 'nav');

        for (const acc of accounts) {
            results.push({
                label: acc.name || `Аккаунт #${acc.id}`,
                path: `#/accounts/${acc.id}`,
                type: 'account',
                hint: acc.slug || '',
            });
        }

        for (const u of users) {
            const name = [u.first_name, u.last_name].filter(Boolean).join(' ') || u.email;
            results.push({
                label: name,
                path: `#/users/${u.id}`,
                type: 'user',
                hint: u.email || u.phone || '',
            });
        }

        renderResults();
    } catch {
        // ignore
    }
}

function renderResults() {
    const el = document.getElementById('cmdResults');
    if (!el) return;

    if (!results.length) {
        el.innerHTML = '<div class="cmd-result-empty">Ничего не найдено</div>';
        return;
    }

    el.innerHTML = results.map((r, i) => `
        <div class="cmd-result${i === selectedIndex ? ' selected' : ''}" data-idx="${i}">
            <span class="cmd-result-icon">${r.type === 'account' ? '🏢' : r.type === 'user' ? '👤' : '📄'}</span>
            <span class="cmd-result-text">${esc(r.label)}</span>
            <span class="cmd-result-hint">${esc(r.hint || (r.type === 'account' ? 'Аккаунт' : r.type === 'user' ? 'Пользователь' : 'Раздел'))}</span>
        </div>
    `).join('');

    el.querySelectorAll('.cmd-result').forEach(item => {
        item.addEventListener('click', () => {
            const idx = parseInt(item.dataset.idx);
            if (results[idx]) navigate(results[idx]);
        });
    });

    // Scroll selected into view
    const selected = el.querySelector('.cmd-result.selected');
    if (selected) selected.scrollIntoView({ block: 'nearest' });
}

function navigate(item) {
    close();
    window.location.hash = item.path;
}

function close() {
    if (overlay) {
        overlay.remove();
        overlay = null;
    }
    clearTimeout(searchTimeout);
}

function esc(str) {
    if (!str) return '';
    return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
